import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const SavedInsights = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = true,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="saved-insights-icon"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8906 8.25532C12.8906 7.83817 13.2344 7.5 13.6585 7.5H17.5279C17.952 7.5 18.2958 7.83817 18.2958 8.25532V17.7901C18.2958 18.2073 17.952 18.5455 17.5279 18.5455H13.7058C13.6902 18.5464 13.6744 18.5469 13.6585 18.5469H9.78908C9.77505 18.5469 9.76109 18.5465 9.7472 18.5458H6.47245C6.04837 18.5458 5.70459 18.2076 5.70459 17.7904V15.5529C5.70459 15.1357 6.04837 14.7975 6.47245 14.7975H9.02123V13.193C9.02123 12.7759 9.36501 12.4377 9.78908 12.4377H12.8906V8.25532ZM14.4264 9.01063V17.0348H16.76V9.01063H14.4264ZM10.5569 13.9483V17.0362H12.8906V13.9483H10.5569ZM7.2403 16.3082V17.0351H9.02123V16.3082H7.2403Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.182 1.99219C6.53389 1.99219 5.99275 2.45005 5.86435 3.05993C4.34855 3.12048 3 4.36267 3 5.88619V18.229C3 19.7912 4.26639 21.0576 5.82857 21.0576H18.1714C19.7336 21.0576 21 19.7912 21 18.229V5.88619C21 4.32401 19.7336 3.05762 18.1714 3.05762H11.9705C11.8413 2.44888 11.3007 1.99219 10.6534 1.99219H7.182ZM4.54286 5.88619C4.54286 5.22343 5.16327 4.67779 5.83547 4.60801L5.83557 10.8608C5.83557 11.1517 5.99989 11.4175 6.26003 11.5476C6.52017 11.6777 6.83146 11.6496 7.06414 11.4751L8.91781 10.0848L10.7714 11.4744C11.0041 11.6489 11.3154 11.6769 11.5755 11.5468C11.8356 11.4167 11.9998 11.1509 11.9999 10.8601L11.9999 4.60047H18.1714C18.8815 4.60047 19.4571 5.17611 19.4571 5.88619V18.229C19.4571 18.9391 18.8815 19.5148 18.1714 19.5148H5.82857C5.11849 19.5148 4.54286 18.9391 4.54286 18.229V5.88619ZM7.37128 9.32511L7.37118 3.5279H10.4642L10.4642 9.32476L9.37829 8.51072C9.10528 8.30605 8.72996 8.30609 8.457 8.51082L7.37128 9.32511Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
